import styled from 'styled-components';
import svgItem from '../../assets/onboarding/safe-hygienic.svg';

const SafeHygienic = styled(svgItem as React.SFC<React.SVGProps<SVGSVGElement>>)(
  props => `
  width: ${props => props.width || '4.4rem'};
  height: ${props => props.height || '4.4rem'};
  rect {
    stroke: ${props.fill || props.theme.colors.grey.grey50};
  }
  fill: ${props => props.fill || props.theme.colors.black.base};
`
);

export default SafeHygienic;
